import baseAPI from '../../axiosApi'

const api={
    list:'/api-ir/bachelor/textbook/page',
    add:'/api-ir/bachelor/textbook/add',
    update:'/api-ir/bachelor/textbook/edit',
    info:'/api-ir/bachelor/textbook/info/',
    del:'/api-ir/bachelor/textbook/delete/',
    listAll:'/api-ir/bachelor/textbook/list',
}
// 查询教材列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增教材
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改教材
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询教材信息
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除教材
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}
// 查询教材列表无分页
export function listAll (data) {
    return baseAPI.axiosData(api.listAll,'get',data)
}
